import { createContext, ReactNode, useContext } from 'react';
import { Contract, useContractQuery } from '@access-cms/api-client';

interface ContractContextValue {
  contractId: string | null;
  contract: Contract | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

const ContractContext = createContext<ContractContextValue | undefined>(undefined);

interface ContractProviderProps {
  children: ReactNode;
  contractId: string;
}

export function ContractProvider({ children, contractId }: ContractProviderProps) {
  const { data, isLoading, isError, error } = useContractQuery(contractId);

  const contract = data ?? null;

  return (
    <ContractContext.Provider
      value={{
        contract,
        contractId: contract?.id ?? null,
        error: error as Error | null,
        isError,
        isLoading,
      }}>
      {children}
    </ContractContext.Provider>
  );
}

export function useContractData() {
  const context = useContext(ContractContext);

  if (context === undefined) {
    throw new Error('useContractData must be used within a ContractProvider');
  }

  return context;
}
